export default "__VITE_ASSET__Bio8PuVP__"